import { Component, OnInit, Output, EventEmitter, Input, OnDestroy, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { ConstantValues } from 'src/app/models/util/constantValues';
import { Subscription } from 'rxjs';
import { EventMappingType, ErrorLevel, ErrorType, TicketType, OddsValidationMode, TicketStatus, RequestSource, BetOutcomeResult, TicketPlayType, TypeOfPlaceBetTicket, SiteViewConfiguration, PlatformHeadrId } from 'src/app/models/enums';
import { TicketService } from 'src/app/services/ticket.service';
import { UserService } from 'src/app/services/user.service';
import { UtilityService } from 'src/app/services/util/utility.service';
import { DeployParams } from 'src/app/deployParams';
import { ITicketItemGroup } from 'src/app/models/ticket/ticketItemGroup.interface';
import { ITicket } from 'src/app/models/ticket/ticket.interface';
import { NotificationService } from 'src/app/services/notification.service';
import { TicketProviderService } from 'src/app/services/providers/ticket.provider.service';
import { ITicketValidationRequestTO } from 'src/app/models/ticket-validation/transportObjects/ticketValidationRequestTO.interface';
import { ModelMapperService } from 'src/app/services/util/model.mapper.service';
import { ICustomNotification } from 'src/app/models/notification/customNotification.interface';
import { ITicketItem } from 'src/app/models/ticket/ticketItem.inerface';
import { ITicketValidationResult } from 'src/app/models/ticket-validation/ticketValidationResult.interface';
import { INotificationDialogEventModel } from 'src/app/models/ticket-validation/notificationDialogEvent.interface';
import { IUpdateTicketRequestObjTO } from 'src/app/models/ticket/transportObjects/ubdateTicketRequestObjTO.interface';
import { IUpdatedTicketItem } from 'src/app/models/ticket-validation/updatedTicketItem.interface';
import { ITicketOutcomeIdentifyer } from 'src/app/models/ticket/ticketOutcomeIdentifyer.interface';
import { IOddContainer } from '../ticket/oddContainer.interface';
import { ITicketConfirmationRequestTO } from 'src/app/models/ticket/transportObjects/ticketConfirmationRequest.interface';
import { ITicketTO } from 'src/app/models/ticket/transportObjects/ticketTO.interface';
import { DynamicTranslations } from 'src/locale/dynamicTranslations';
import { LocaleHelper } from 'src/locale/LocaleHelper';
import { ITicketDialogModel } from 'src/app/models/ticket-validation/ticketDialogModel.interface';
import { StorageService } from 'src/app/services/util/storage.service';
import { ITicketOrderingItem } from 'src/app/models/ticket/ticketOrderingItem';
import { LoaderService } from 'src/app/services/loader.service';
import { BonusService } from 'src/app/services/bonus.service';
import { FreeBetService } from 'src/app/services/freeBet.service';
import { CacheChangesService } from 'src/app/services/cacheChanges.service';
import { ICacheChanges } from 'src/app/models/cacheChanges/cacheChanges.interface';
import { ChangesUpdaterService } from 'src/app/services/changesUpdaterService.service';
import { ViewConfigurations } from 'src/app/models/util/viewConfigurations';
import { IUserTM } from 'src/app/ticket-manager/models/user/userTM.interface';
import { TicketManagerUserService } from 'src/app/ticket-manager/services/ticketManagerUser.service';
import { AuthenticationService } from 'src/app/ticket-manager/services/authentication.service';
import { CashOutService } from 'src/app/services/cash-out.service';
import { IAffiliate } from 'src/app/ticket-manager/models/user/affiliate.interface';
import { AffiliateRole } from 'src/app/ticket-manager/models/util/tmEnums';
import { TicketManagerTicketService } from 'src/app/ticket-manager/services/ticket-manager-ticket.service';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-ticket-dialog',
  templateUrl: './ticket-dialog.component.html',
  styleUrls: ['./ticket-dialog.component.less']
})

export class TicketDialogComponent implements OnInit, OnDestroy, AfterViewInit {
  public currency = ConstantValues.CURRENCY;
  public showDialog = true;
  public dynamicTranslations = DynamicTranslations;
  public ticketItemsLength: number;
  public language: string;
  protected subscription: Subscription = new Subscription();
  public selectedSystemOptions;
  public taxBeforeStakeDefinitionPercent;
  viewConfigurations = ViewConfigurations;



  public receiveNotification = true;
  public maxTotalOdd = ConstantValues.MAX_TOTAL_ODD;
  public errorMsg: string;
  public isUserLoggedIn = false;
  public accountBalance = 0;
  public freeBetBalance = 0;
  public ticketTypeEnum = TicketType;
  public timeToAccept = 0;
  private interval;
  public eventMappingTypeEnum = EventMappingType;
  public languageCulture: string;
  public orderingForTicketItemGroups: ITicketOrderingItem[] = [];
  public isMobileView: boolean;
  public oddsValidationModeEnum = OddsValidationMode;
  isUserLoggedInForNot = false;
  public tmUser: IUserTM;
  public affiliate: IAffiliate;
  public affiliateRoleEnum = AffiliateRole;
  public playedTicketPinCodeInput: string;
  public isStornoPossible: boolean;


  oddsMap: { [eventId: number]: number } = {};
  minOddsMap: { [eventId: number]: number } = {};

  // eslint-disable-next-line @typescript-eslint/naming-convention
  public ticketPlayTypeEnum = TicketPlayType;

  // For later
  // @Output()
  // showConfirmDialog = new EventEmitter<boolean>();
  // @Output()
  // updateTicket = new EventEmitter<{ event: IUpdatedTicketItem, newStake: number }>();

  @Input()
  dialogModel: ITicketDialogModel;

  ticketStatusEnum = TicketStatus;
  betOutcomeResultEnum = BetOutcomeResult;
  scroll = 0;
  // public ticketItemGroups: { [eventId: number]: ITicketItemGroup } = {}; // get it from service on init

  constructor(
    protected notificationService: NotificationService,
    protected ticketService: TicketService,
    protected ticketProvider: TicketProviderService,
    protected userService: UserService,
    protected utilityService: UtilityService,
    protected storageService: StorageService,
    protected modelMapper: ModelMapperService,
    protected bonusService: BonusService,
    protected freeBetService: FreeBetService,
    protected changesUpdater: ChangesUpdaterService,
    protected cacheChangesService: CacheChangesService,
    protected loaderService: LoaderService,
    protected ticketManagerUserService: TicketManagerUserService,
    protected authentificationService: AuthenticationService,
    protected cashOutService: CashOutService,
    protected router: Router,
    protected ticketServiceTM: TicketManagerTicketService) {

    this.language = storageService.language;
    this.languageCulture = LocaleHelper.cultureName[storageService.language];
    this.userService.getNewBalancesFromServer();
    this.subscription.add(this.cacheChangesService.cacheUpdatedPM$.subscribe((c) => this.updateTicket(c, false)));
    this.subscription.add(this.cacheChangesService.cacheUpdatedLive$.subscribe((c) => this.updateTicket(c, true)));
    this.subscription.add(this.userService.freebetChanged$.subscribe(() => {
      this.freeBetBalance = storageService.freeBetBalance;
      this.calculateFreeBet();
    }));
    this.subscription.add(this.userService.accountBalanceChanged$.subscribe(() => this.accountBalance = storageService.accountBalance));
    this.subscription.add(this.authentificationService.loggedAffiliateChangedSource$.subscribe(() => this.accountBalance = storageService.accountBalance));

    this.accountBalance = storageService.accountBalance;
    this.freeBetBalance = storageService.freeBetBalance;
    if (environment.localDeploy) {
      this.accountBalance = 90000;
      this.freeBetBalance = 85000;
    }

    this.errorMsg = DynamicTranslations.ticketValidation_maxTotalOdd.toUpperCase();
    // this.closeDialogSub = this.notificationService.closeConfirmTicketDialog$.subscribe(x => this.closeDialog());

    // this.ticketItemGroups = this.ticketService.ticketItemGroups;

    this.isUserLoggedIn = false;

    if (this.userService.user.userSBToken) {
      this.isUserLoggedIn = true;
    }

    if (this.authentificationService.loggedAffiliate && storageService.affiliateJwtToken) {
      this.isUserLoggedIn = true;
    }

    this.subscription.add(this.userService.userLoggedInOut$.subscribe((x) => {
      this.isUserLoggedIn = x;
      if (this.isUserLoggedIn || (this.authentificationService.loggedAffiliate && storageService.affiliateJwtToken)) {
        this.dialogModel.typeOfPlaceBetTicket = TypeOfPlaceBetTicket.Standard;
      } else {
        this.dialogModel.typeOfPlaceBetTicket = TypeOfPlaceBetTicket.Express;
      }
    }));

    this.subscription.add(this.authentificationService.loggedAffiliateChangedSource$.subscribe(() => {
      if (this.authentificationService.loggedAffiliate && storageService.affiliateJwtToken) {
        this.isUserLoggedIn = true;
      } else {
        this.isUserLoggedIn = true;
      }
      if (this.isUserLoggedIn) {
        this.dialogModel.typeOfPlaceBetTicket = TypeOfPlaceBetTicket.Standard;
      } else {
        this.dialogModel.typeOfPlaceBetTicket = TypeOfPlaceBetTicket.Express;
      }
      this.accountBalance = storageService.accountBalance;
    }));

    this.isMobileView = utilityService.mobileView;
    this.tmUser = ticketManagerUserService.user;
    this.affiliate = this.authentificationService.loggedAffiliate;
    this.subscription.add(this.ticketManagerUserService.tmUserChangedSource$.subscribe(() => this.tmUser = ticketManagerUserService.user));
  }

  ngAfterViewInit() {
    if (!this.isMobileView && this.isUserLoggedIn) {
      this.validateTicketPinInput();
    }
  }

  protected calculateFreeBet() {
    const freebets = this.ticketService.calculateFreeBet(this.freeBetService.playerFreeBetSettings,
      this.freeBetBalance,
      this.dialogModel.ticketData.numberOfBets,
      this.orderingForTicketItemGroups,
      this.dialogModel.ticketData.wagerPerBet,
      this.dialogModel.ticketData.totalOdd,
      this.dialogModel.ticketData.totalWinings,
      this.dialogModel.ticketData.bonus,
      this.dialogModel.ticketData.totalStake);
    this.dialogModel.ticketData.freeBetValue = freebets.freeBetValue;
    this.dialogModel.ticketData.freeBetValueToShow = freebets.freeBetValueToShow;
  }

  validateTicketPinInput() {
    const ticketPin = document.getElementById('pinInputTicketDialog');
    if (ticketPin) {
      if (ticketPin) {
        // console.log('ticketPin');
        ticketPin.addEventListener('input', (e) => {
          const target = e.currentTarget as HTMLInputElement;
          target.value = target.value.replace(/\D+/g, '').replace(/(.{5})/g, '$1 ').trim();
        });
      }
    }
  }

  rebet() {
    let sysEvInCombination: number[] = [];
    if (this.dialogModel.systemName && this.dialogModel.systemName.length > 0) {
      const systems = this.dialogModel.systemName.trim().split('/');
      if (systems[0].length > 0) {
        const sysEvents = systems[0].split(',');
        if (sysEvents.length > 0) {
          sysEvInCombination = sysEvents.map(e => +e);
        }
      }
    }
    this.ticketService.getNewItemStatusesForRebetAndAddToTicket(
      this.dialogModel.ticketItemEventGroups,
      this.dialogModel.bankerTicketItemGroups.map(g => g.eventId),
      this.dialogModel.systemTicketItemGroups ? this.dialogModel.systemTicketItemGroups.map(g => g.eventId) : [],
      this.dialogModel.isFix,
      this.dialogModel.ticketData.payin,
      sysEvInCombination.length > 0 ? sysEvInCombination : null);


    this.closeDialog();
    this.router.navigate(['/account/cashdesk']);

  }

  updateTicket(cacheChanges: ICacheChanges, isLive: boolean) {
    if (this.dialogModel.ticketType !== TicketPlayType.PlaceBet && this.dialogModel.ticketType !== TicketPlayType.ChangedTicket) {
      return;
    }

    const eventIdsWithChangedOdds: number[] = this.changesUpdater.updateTicketItemGroups(cacheChanges, this.dialogModel.ticketItemEventGroups, this.languageCulture);
    if (eventIdsWithChangedOdds.length > 0) {
      this.setMinAndMaxOddMaps(eventIdsWithChangedOdds);
      if (this.dialogModel.isFix) {
        this.dialogModel.ticketData = this.ticketService.calculateOddAndWiningsTicketFix(this.oddsMap,
          this.minOddsMap,
          this.dialogModel.ticketData.totalStake,
          this.dialogModel.ticketData.wagerPerBet,
          this.dialogModel.ticketData.numberOfBets,
          this.freeBetService.playerFreeBetSettings,
          this.freeBetBalance,
          this.bonusService.playerBonussSettings,
          this.bonusService.bonussSettings,
          this.orderingForTicketItemGroups,
          this.dialogModel.ticketData.payin,
          this.dialogModel.ticketData.taxBeforeStake);
      } else {
        const selectedSysOpts = this.dialogModel.systemOptions.filter(sysopt => sysopt.optionSelected);
        this.ticketService.updateOddsSystemOptions(
          selectedSysOpts,
          this.orderingForTicketItemGroups,
          this.dialogModel.systemTicketItemGroups,
          this.dialogModel.bankerTicketItemGroups,
          this.oddsMap,
          this.minOddsMap,
          this.dialogModel.hasLiveItems,
          this.dialogModel.maxOddsSysEvIdsByOddHiToLowWithoutBankers ? this.dialogModel.maxOddsSysEvIdsByOddHiToLowWithoutBankers : [],
          this.dialogModel.minOddsSysEvIdsByOddLowToHiWithoutBankers ? this.dialogModel.minOddsSysEvIdsByOddLowToHiWithoutBankers : []);
        this.dialogModel.ticketData = this.ticketService.calculateOddsAndWinningsForUpdatedSystemOptions(
          selectedSysOpts,
          this.freeBetService.playerFreeBetSettings,
          this.bonusService.playerBonussSettings,
          this.bonusService.bonussSettings,
          this.freeBetBalance,
          this.dialogModel.isFix,
          this.orderingForTicketItemGroups,
          this.dialogModel.ticketData.wagerPerBet,
          this.dialogModel.ticketData.totalStake,
          this.dialogModel.ticketData.numberOfBets,
          this.dialogModel.ticketData.payin,
          this.dialogModel.ticketData.taxBeforeStake,
          !this.dialogModel.hasLiveItems && ViewConfigurations.showNumberOfHitsForTicketSystem);
      }
    }
    this.dialogModel.ticketData.isTicketOnline = this.ticketService.isTicketOnline(this.dialogModel.ticketItemEventGroups);
    if (ViewConfigurations.showDialogOnOddChangeBeforePlaceBet && this.dialogModel.ticketType === TicketPlayType.PlaceBet) {
      this.dialogModel.ticketData.hasLowerOdds = this.getHasLowerOdds();
    }
  }

  private getHasLowerOdds(): boolean {
    for (const eventGroup of Object.values(this.dialogModel.ticketItemEventGroups)) {
      for (const ticketItem of Object.values(eventGroup.ticketItems)) {
        if (ticketItem.odd < ticketItem.oldOdd) {
          return true;
        }
      }
    }
    return false;
  }

  setMinAndMaxOddMaps(evenIds: number[]) {
    for (const eventId of evenIds) {
      const eventOdds: IOddContainer = this.ticketService.getMInAndMaxOddForEvent(
        eventId,
        Object.entries(this.dialogModel.ticketItemEventGroups[eventId].ticketItems).map(([k, ti]) => ({ outcomeId: ti.betOutcomeId, outcomeTypeId: ti.betTypeOutcomeId })),
        this.dialogModel.ticketItemEventGroups
      );

      this.oddsMap[eventId] = eventOdds.maxOdd;
      this.minOddsMap[eventId] = eventOdds.minOdd;
    }
  }

  ngOnInit() {
    if (this.dialogModel.ticketType === TicketPlayType.PlayedTicket && TicketStatus.Pending === this.dialogModel.confirmationOrPlayedTicket?.statusId
      || TicketStatus.Open === this.dialogModel.confirmationOrPlayedTicket?.statusId) {
      const date = new Date(this.dialogModel.confirmationOrPlayedTicket.payoutDate);
      date.setMinutes(date.getMinutes() + ConstantValues.STORNO_ALLOWED_MINUTES);
      if (date > new Date()) {
        this.isStornoPossible = true;
      }
    }
    if (this.dialogModel.systemOptions?.length > 0) {
      this.selectedSystemOptions = this.dialogModel.systemOptions.filter(so => so.optionSelected);
    }
    const evIds = [];
    this.orderingForTicketItemGroups = Object.entries(this.dialogModel.ticketItemEventGroups).map(([eventId, group]) => {
      evIds.push(+eventId);
      return {
        eventId: +eventId,
        outcomeIds: Object.keys(group.ticketItems).map(k => +k)
      };
    });
    this.ticketItemsLength = this.orderingForTicketItemGroups.length;

    this.setMinAndMaxOddMaps(evIds);
    if (this.dialogModel.ticketType === TicketPlayType.ConfirmationTicket) {
      this.startAcceptTimer();
    }

    if (this.dialogModel.ticketType === TicketPlayType.ChangedTicket) {
      if (this.dialogModel.isFix) {
        this.dialogModel.ticketData = this.ticketService.calculateOddAndWiningsTicketFix(this.oddsMap,
          this.minOddsMap,
          this.dialogModel.ticketData.totalStake,
          this.dialogModel.ticketData.wagerPerBet,
          this.dialogModel.ticketData.numberOfBets,
          this.freeBetService.playerFreeBetSettings,
          this.freeBetBalance,
          this.bonusService.playerBonussSettings,
          this.bonusService.bonussSettings,
          this.orderingForTicketItemGroups,
          this.dialogModel.ticketData.payin,
          this.dialogModel.ticketData.taxBeforeStake);
      } else {
        const recievedBonus = this.dialogModel.ticketData.bonus;
        const recievedBonusPercent = this.dialogModel.ticketData.bonusPercent;

        this.ticketService.updateOddsSystemOptions(
          this.dialogModel.systemOptions,
          this.orderingForTicketItemGroups,
          this.dialogModel.systemTicketItemGroups,
          this.dialogModel.bankerTicketItemGroups,
          this.oddsMap,
          this.minOddsMap,
          this.dialogModel.hasLiveItems,
          this.dialogModel.maxOddsSysEvIdsByOddHiToLowWithoutBankers ? this.dialogModel.maxOddsSysEvIdsByOddHiToLowWithoutBankers : [],
          this.dialogModel.minOddsSysEvIdsByOddLowToHiWithoutBankers ? this.dialogModel.minOddsSysEvIdsByOddLowToHiWithoutBankers : []);
        this.dialogModel.ticketData = this.ticketService.calculateOddsAndWinningsForUpdatedSystemOptions(this.dialogModel.systemOptions,
          this.freeBetService.playerFreeBetSettings,
          this.bonusService.playerBonussSettings,
          this.bonusService.bonussSettings,
          this.freeBetBalance,
          this.dialogModel.isFix,
          this.orderingForTicketItemGroups,
          this.dialogModel.ticketData.wagerPerBet,
          this.dialogModel.ticketData.totalStake,
          this.dialogModel.ticketData.numberOfBets,
          this.dialogModel.ticketData.payin,
          this.dialogModel.ticketData.taxBeforeStake,
          false);
        this.dialogModel.ticketData.bonus = recievedBonus;
        this.dialogModel.ticketData.bonusPercent = recievedBonusPercent;
      }
      this.dialogModel.ticketData.isTicketOnline = this.ticketService.isTicketOnline(this.dialogModel.ticketItemEventGroups);
    }

    if (this.dialogModel.ticketType === TicketPlayType.PlayedTicket && !this.dialogModel.isFix && !this.dialogModel.hasLiveItems && this.viewConfigurations.showNumberOfHitsForTicketSystem) {
      const recievedBonus = this.dialogModel.ticketData.bonus;
      const recievedBonusPercent = this.dialogModel.ticketData.bonusPercent;

      this.ticketService.updateOddsSystemOptions(this.dialogModel.systemOptions, this.orderingForTicketItemGroups, this.dialogModel.systemTicketItemGroups, this.dialogModel.bankerTicketItemGroups, this.oddsMap, this.minOddsMap, this.dialogModel.hasLiveItems, this.dialogModel.maxOddsSysEvIdsByOddHiToLowWithoutBankers ? this.dialogModel.maxOddsSysEvIdsByOddHiToLowWithoutBankers : [], this.dialogModel.minOddsSysEvIdsByOddLowToHiWithoutBankers ? this.dialogModel.minOddsSysEvIdsByOddLowToHiWithoutBankers : []);
      const data = this.ticketService.calculateOddsAndWinningsForUpdatedSystemOptions(this.dialogModel.systemOptions, null, [], [], 0, this.dialogModel.isFix, this.orderingForTicketItemGroups, this.dialogModel.ticketData.wagerPerBet, this.dialogModel.ticketData.totalStake, this.dialogModel.ticketData.numberOfBets, this.dialogModel.ticketData.payin, this.dialogModel.ticketData.taxBeforeStake, !this.dialogModel.hasLiveItems && ViewConfigurations.showNumberOfHitsForTicketSystem, false);
      this.dialogModel.ticketData.bonus = recievedBonus;
      this.dialogModel.ticketData.bonusPercent = recievedBonusPercent;
      this.dialogModel.ticketData.possibleWinForNumberOfHits = data.possibleWinForNumberOfHits;
      // this.dialogModel.ticketData.possibleWinForNumberOfHits[this.dialogModel.ticketData.possibleWinForNumberOfHits.length - 1].maxWinnings = this.dialogModel.ticketData.possibleWinWithoutTax;
    }

    if (this.dialogModel.ticketType === TicketPlayType.ConfirmationTicket) {
      this.dialogModel.ticketData.isTicketOnline = this.ticketService.isTicketOnline(this.dialogModel.ticketItemEventGroups);
    }

    if (this.dialogModel.ticketType === TicketPlayType.PlayedTicket && this.dialogModel.confirmationOrPlayedTicket?.statusId === TicketStatus.Pending) {
      if (this.storageService.affiliate && this.dialogModel.confirmationOrPlayedTicket.createdBy && this.dialogModel.confirmationOrPlayedTicket.createdBy !== this.storageService.affiliate.affiliateId) {
        this.dialogModel.confirmationOrPlayedTicket.cashOutValue = 0;
      } else {
        this.cashOutService.updateCashOutValueTicket(this.dialogModel.confirmationOrPlayedTicket);
      }
    }

    const interval = setInterval(() => { this.setDialogPosition(interval); }, 100);

    if (this.userService.user.userName) {
      this.isUserLoggedInForNot = true;
    } else {
      this.isUserLoggedInForNot = false;
    }

    if (ConstantValues.TAX_DEFINITIONS.taxBeforeStakeDefinition && ConstantValues.TAX_DEFINITIONS.taxBeforeStakeDefinition.stakePercent) {
      this.taxBeforeStakeDefinitionPercent = ConstantValues.TAX_DEFINITIONS.taxBeforeStakeDefinition.stakePercent;
    }
  }


  sellBet(): void {
    if (!this.isPinOk()) {
      return;
    }
    this.cashOutService.sellBet(this.modelMapper.mapPlayedTicketFromTicketDialogModel(this.dialogModel), !!this.authentificationService.loggedAffiliate, this.playedTicketPinCodeInput);

    this.closeDialog();
  }

  closeDialog() {
    this.notificationService.forwardDataToTicketDialog(null);
    this.enableParentScroll();

  }

  startAcceptTimer() {
    this.timeToAccept = this.dialogModel.hasLiveItems? ConstantValues.TICKET_ACCEPT_TIME_SEC_LIVE : ConstantValues.TICKET_ACCEPT_TIME_SEC_PM;
    this.interval = setInterval(() => {
      if (this.timeToAccept > 1) {
        this.timeToAccept--;
      } else {
        this.stopAcceptTimer();
        this.closeDialog();
      }
    }, 1000);
  }

  stopAcceptTimer() {
    this.timeToAccept = 0;
    clearInterval(this.interval);
  }

  fastTicket(): void {
    if (this.maxTotalOdd < this.dialogModel.ticketData.totalOdd) {
      return;
    }
    if (!this.dialogModel.hasLiveItems || ViewConfigurations.enableFastTicketLive) {
      const ticket = this.createTicket();
      ticket.isFastTicket = true;
      this.placeFastBet(ticket, false);
    } else {
      const notification: ICustomNotification = {
        title: DynamicTranslations.notification_title,
        message: DynamicTranslations.notification_mustBePrematch_ErrorMessage,
        errorLevel: ErrorLevel.Notification,
      } as ICustomNotification;
      this.notificationService.forwardDataToNotification(notification);
    }
  }

  createTicket(): ITicket {
    if (this.dialogModel.isFix) {
      return this.ticketService.createTicketFix(this.dialogModel.ticketData.freeBetValue,
        this.freeBetService.playerFreeBetSettings,
        this.orderingForTicketItemGroups,
        this.dialogModel.ticketItemEventGroups, this.dialogModel.ticketData);
    } else {
      return this.ticketService.createSystemTicket(this.dialogModel.bankerTicketItemGroups, this.dialogModel.systemTicketItemGroups, this.dialogModel.isMultiplayBanker, this.dialogModel.isMultiplaySystem, this.dialogModel.systemOptions, this.dialogModel.ticketData.freeBetValue, this.freeBetService.playerFreeBetSettings, this.dialogModel.ticketData);
    }
  }

  freeBetTicket(): void {
    const ticket = this.createTicket();
    if (this.maxTotalOdd < ticket.totalOdd) {
      return;
    }
    ticket.isFreeBet = true;
    ticket.possibleWin = this.dialogModel.ticketData.freeBetValue;
    ticket.possibleWinWithoutBonus = this.dialogModel.ticketData.freeBetValue;
    this.makeRequest(ticket);
  }


  confirmBet(request: ITicketValidationRequestTO): void {
    if (this.userService.user.userSBToken || (this.authentificationService.loggedAffiliate && this.storageService.affiliateJwtToken)) {
      request.ticket.isFastTicket = false;
      // this.saveSentOdds(request.ticket);
      // sent odds to server are becoming old odds now(not odds added to ticket, if something is changed we need to show that changes)
      request.ticket.groups.forEach(group => {
        // tslint:disable-next-line:forin
        for (const key in group.ticketItems) {
          if (group.ticketItems.hasOwnProperty(key)) {
            const ticketItem = group.ticketItems[key];
            ticketItem.requestedOdd = ticketItem.acceptedOdd;
            // ticketItem.oldOdd = this.sentOdds[ticketItem.betOutcomeId];
          }
        }
      });
      // jQuery('.loader-wrap').fadeIn();
      // this.loaderService.showHideLoader(true);
      this.placeBet(request);
      this.closeDialog();
    } else {
      const notification: ICustomNotification = {
        errorType: ErrorType.CloseDialog,
        title: DynamicTranslations.notification_title,
        message: DynamicTranslations.notification_notLoggedIn_ErrorMessage,
        errorLevel: ErrorLevel.Notification,
      } as ICustomNotification;
      // jQuery('.loader-wrap').fadeOut();
      this.notificationService.forwardDataToNotification(notification);
    }
  }

  // get isTicketOnline(): boolean {
  //   const ticketItemGroups: ITicketItemGroup[] = Object.entries(this.dialogModel.ticketItemEventGroups).map(([k, v]) => v);
  //   for (const group of ticketItemGroups) {
  //     if (!group.isEventPlayable) {
  //       return false;
  //     } else {
  //       const ticketItems: ITicketItem[] = Object.entries(group.ticketItems).map(([k, v]) => v);
  //       if (ticketItems.findIndex(ti => !ti.isBetOutcomePlayable || !ti.isBetPlayable || ti.odd === 1) !== -1) {
  //         return false;
  //       }
  //     }
  //   }
  //   return true;
  // }


  placeFastBet(ticket: ITicket, authorizedTicketConfirmation: boolean): void {
    this.ticketService.placeFastBet(this.dialogModel.validationMode, ticket, authorizedTicketConfirmation, this.dialogModel, this.receiveNotification);
  }

  placeBet(request: ITicketValidationRequestTO): void {
    this.ticketService.placeBetWithRequest(request, this.dialogModel, this.receiveNotification);
  }

  // saveSentOdds(ticket: ITicketTO): void {
  //   ticket.groups.forEach(gr => {
  // eslint-disable-next-line
  //     for (const key in gr.ticketItems) {
  //       const value = gr.ticketItems[key];
  //       this.sentOdds[value.betOutcomeId] = value.acceptedOdd;
  //     }
  //   });
  // }

  placeStandardBet() {
    this.makeRequest(this.createTicket());
  }

  cancelTicket() {
    if (this.dialogModel.isTicketChangedWebCheck) {
      this.closeDialog();
      return;
    }
    if (this.dialogModel.confirmationOrPlayedTicket.ticketValidationId) {
      this.ticketService.cancelTicket(this.dialogModel.confirmationOrPlayedTicket);
    }

    // this.ticketService.removeAllTicketItemsSource.next();
    this.closeDialog();
  }

  setDialogPosition(interval) {
    if (document.getElementById('ticketDetailWrap') === null) { return; }
    const ticketDetailWrap = document.getElementById('ticketDetailWrap');
    // let scrollTop = environment.localDeploy ? 0 : window.parent.scrollY;
    let scrollTop = 0;
    // const scrollTop = environment.localDeploy ? 0 : window.parent.document.getElementById('container').scrollTop;
    const windowHeight = window.parent.innerHeight;
    const documentHeight = document.body.clientHeight;

    // set max height on dialog
    if (windowHeight < documentHeight) {
      ticketDetailWrap.style.maxHeight = windowHeight - 30 + 'px';
    } else {
      ticketDetailWrap.style.maxHeight = documentHeight - 30 + 'px';
    }

    // set scroll not to be over footer
    if (windowHeight + scrollTop > documentHeight) {
      window.parent.scroll(0, documentHeight - windowHeight);
      scrollTop = documentHeight - windowHeight;

      if (scrollTop < 0) {
        scrollTop = 0;
      }
    }

    // position dialog
    if (scrollTop + windowHeight - 30 < documentHeight) {
      const move = scrollTop + (windowHeight - ticketDetailWrap.offsetHeight) / 2;
      // console.log(move);
      // ticketDetailWrap.style.transform = 'translate(0px, ' + move + 'px)';
    } else {
      const move = scrollTop + (documentHeight - ticketDetailWrap.offsetHeight) / 2;
      // console.log(move);
      // ticketDetailWrap.style.transform = 'translate(0px, ' + move + 'px)';
      // const move = documentHeight - windowHeight;
      // ticketDetailWrap.style.transform = 'translate(0px, 15px)';
    }


    setTimeout(() => {
      ticketDetailWrap.style.opacity = '1';
      ticketDetailWrap.style.transition = 'none';

      this.disableParentScroll();
    }, 200);


    clearInterval(interval);
  }

  disableParentScroll() {
    // window.parent.document.documentElement.style.overflow = 'hidden';

    if (document.body.offsetHeight > window.innerHeight) {
      this.scroll = document.body.offsetHeight - window.innerHeight;
      window.parent.document.documentElement.classList.add('disable-scroll');
      // window.parent.document.documentElement.style.top = - this.scroll + 'px';
    } else {
      window.parent.document.documentElement.style.overflow = 'hidden';
    }
  }

  enableParentScroll() {
    window.parent.document.documentElement.style.overflow = 'auto';

    if (this.scroll > 0) {
      document.getElementsByTagName('html')[0].classList.remove('disable-scroll');
      // window.parent.scroll(0, this.scroll);
    }
    // window.parent.document.documentElement.removeAttribute('style');
  }

  getSportName(sportId: number) {
    return this.utilityService.getSportIcon(sportId);
  }

  // showConfirmAndRecalculate(response: ITicketValidationResult) {
  //   this.dialogModel.ticketType = TicketPlayType.ConfirmationTicket;
  //   Object.entries(this.dialogModel.ticketItemEventGroups).forEach(([k, gr]) => {
  //     const ticketItems: ITicketItem[] = Object.entries(gr.ticketItems).map(([k, v]) => v);
  //     ticketItems.forEach( ti => {
  //       ti.oldOdd = this.sentOdds[ti.betOutcomeId];

  //       const index = response.validatedTicket.ticketValidationState.updatedTicketItems.findIndex(up => up.betOutcomeId === ti.betOutcomeId);

  //       if (index !== -1) {
  //         const updatedTicketItem = response.validatedTicket.ticketValidationState.updatedTicketItems[index];
  //         if (ti.odd !== updatedTicketItem.updatedOdd) {
  //           ti.odd = updatedTicketItem.updatedOdd;
  //           this.ticketService.ticketItemGroups[gr.eventId].ticketItems[ti.betOutcomeId] = ti;
  //           updatedTicketItem.betOutcomeId = gr.eventId;
  //           const itemsOnEvent: ITicketOutcomeIdentifyer[] = ticketItems.map(ti => {
  //             return { outcomeId: ti.betOutcomeId, outcomeTypeId: ti.betOutcomeId };
  //           });
  //           const oddForEvent: IOddContainer = this.ticketService.getMInAndMaxOddForEvent(gr.eventId, itemsOnEvent);
  //           updatedTicketItem.updatedOdd = oddForEvent.maxOdd;
  //           updatedTicketItem.minOdd = oddForEvent.minOdd;
  //           // for later
  //          // this.updateTicket.emit({ event: updatedTicketItem, newStake: null });
  //         }
  //       }

  //     });
  //   });
  // }

  changeOddsValidationMode(oddsValidationMode: OddsValidationMode) {
    this.ticketService.notifyOddsValidationChange(oddsValidationMode);
  }

  receiveNotificationChange() {
    this.receiveNotification = !this.receiveNotification;
  }

  makeRequest(ticket: ITicket) {
    this.stopAcceptTimer();
    if (this.maxTotalOdd < this.dialogModel.ticketData.totalOdd) {
      return;
    }
    // this.dialogModel.isPlaceBet = true;
    let request: ITicketValidationRequestTO;
    // if (this.ticket.freeBetProcessingType){
    //     this.ticket.isFreeBet = true;
    // }
    if (this.dialogModel.ticketType === TicketPlayType.ConfirmationTicket) {
      request = this.modelMapper.makeTicketValidationRequest(OddsValidationMode.None, ticket, true, this.tmUser && this.tmUser.loggedOffice ? this.tmUser.loggedOffice.id : environment.betWebOfficeId);
      request.ticket.webPlatformCurrency = this.userService.user.userCurrency;
      request.ticket.webPlatformLanguage = this.userService.user.userLanguage;
      request.ticket.platformCustomerId = +this.userService.user.userName;
    } else {
      request = this.modelMapper.makeTicketValidationRequest(OddsValidationMode.None, ticket, false, this.tmUser && this.tmUser.loggedOffice ? this.tmUser.loggedOffice.id : environment.betWebOfficeId);
    }
    request.oddsValidationMode = this.dialogModel.validationMode;
    request.ticketSource = RequestSource.Web;
    this.confirmBet(request);
  }

  // za storno i za payout otvori dialog za unos pina
  stornoTicket() {
    if (ViewConfigurations.requestPinForStornoAndPayout && !this.isPinOk()) {
      return;
    }
    this.ticketServiceTM.stornoTicket(this.dialogModel.confirmationOrPlayedTicket.ticketId, this.playedTicketPinCodeInput).subscribe(isSuccess => {
      if (isSuccess) {
        this.closeDialog();
      }
    });
  }

  payoutTicket() {
    if (ViewConfigurations.requestPinForStornoAndPayout && !this.isPinOk()) {
      return;
    }
    this.ticketServiceTM.payoutTicket(this.dialogModel.confirmationOrPlayedTicket.ticketId, this.playedTicketPinCodeInput, this.dialogModel.confirmationOrPlayedTicket.statusId).subscribe(isSuccess => {
      if (isSuccess) {
        this.closeDialog();
      }
    });
  }

  isPinOk(): boolean {
    if (this.playedTicketPinCodeInput?.length !== 4 || isNaN(+this.playedTicketPinCodeInput)) {
      const notification = {
        title: DynamicTranslations.notification_title,
        message: DynamicTranslations.findTicket_ticketPinShortMessage,
        errorLevel: ErrorLevel.Warning,
        errorType: ErrorType.Warning,
      };
      this.notificationService.forwardDataToNotification(notification as ICustomNotification);
      return false;
    }
    return true;
  }

  generatePdfFromTicket() {
    const DATA1: HTMLElement = document.getElementsByClassName('ticket-dialog-wrap')[0] as HTMLElement;
    this.utilityService.generatePdfFromTicket(DATA1, this.dialogModel.confirmationOrPlayedTicket?.ticketId);

  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
